// extracted by mini-css-extract-plugin
export default {"empresaResumoDiv":"notasSelecao_empresaResumoDiv__jeFLV","empresaResumoValor":"notasSelecao_empresaResumoValor__1-gYy"};